"use strict";

define('controller/submission/list',['require','exports','module','../base','underscore','uikit/uikit','view/page.list','view/decision.header','templates','config','model/user','model/document','model/sort','libs/format/link','libs/format/template','libs/format/empty','libs/format/date','libs/format/reviewType','libs/format/status','libs/filter_format/analyst','langs','handlebars','view/empty.table','evisions/redactor.plugins/macro.redactor.plugin','evisions/redactor.plugins/disabled.redactor.plugin'],function (require, exports, module) {
  'use strict';

  var RegionController = require('../base'),
    _ = require('underscore'),
    UIKit = require('uikit/uikit'),
    PageList = require('view/page.list'),
    DecisionHeaderView = require('view/decision.header'),
    Templates = require('templates'),
    config = require('config'),
    User = require('model/user'),
    Document = require('model/document'),
    Sort = require('model/sort'),
    linkFormatter = require('libs/format/link'),
    templateFormatter = require('libs/format/template'),
    emptyFormatter = require('libs/format/empty'),
    dateFormatter = require('libs/format/date'),
    reviewTypeFormatter = require('libs/format/reviewType'),
    statusFormatter = require('libs/format/status'),
    analystFormatter = require('libs/filter_format/analyst'),
    langs = require('langs'),
    Handlebars = require('handlebars'),
    EmptyTableView = require('view/empty.table');
  require('evisions/redactor.plugins/macro.redactor.plugin');
  require('evisions/redactor.plugins/disabled.redactor.plugin');
  var Loader = UIKit.Loader;
  var ButtonView = UIKit.Button;
  var CheckboxView = UIKit.Checkbox;
  var InputView = UIKit.Input;
  var DropdownView = UIKit.Dropdown;
  var TokenInputView = UIKit.TokenInput;
  var p = langs.phrase;
  function submissionColumns(role) {
    var columns = [{
      data: 'studyLabel',
      text: p('SubmissionPage.Columns.StudyLabel'),
      formatter: linkFormatter('submission:detail', {
        studyId: 'studyId',
        documentId: 'id'
      }),
      sortable: false,
      nowrap: true
    }, {
      data: 'studyTitle',
      text: 'Submission',
      formatter: templateFormatter(Templates.IRB['title.cell'], {
        header: 'studyTitle',
        subHeader: 'templateType'
      }),
      sortable: false,
      maxWidth: '20em'
    }, {
      data: 'status',
      text: p('SubmissionPage.Columns.Status'),
      formatter: statusFormatter(),
      sortable: false
    }, {
      data: 'reviewType',
      text: p('SubmissionPage.Columns.ReviewType'),
      formatter: reviewTypeFormatter,
      sortable: false
    }, {
      data: 'principalInvestigator',
      text: p('SubmissionPage.Columns.PI'),
      formatter: emptyFormatter(new Handlebars.SafeString('<i>Unassigned</i>')),
      sortable: false
    }];
    if (role === User.IRB_ANALYST) {
      columns.push({
        data: 'analyst',
        text: p('SubmissionPage.Columns.Analyst'),
        formatter: emptyFormatter(new Handlebars.SafeString('<i>Unassigned</i>')),
        sortable: false
      });
    }
    if (role === User.IRB_ANALYST || role === User.IRB_ADMIN) {
      columns.push({
        data: 'primaryReviewer',
        text: p('SubmissionPage.VSFields.PrimaryReviewer'),
        formatter: emptyFormatter(new Handlebars.SafeString('<i>Unassigned</i>')),
        sortable: false
      });
    }
    if (role === User.IRB_USER || role === User.IRB_REVIEWER) {
      columns.push({
        data: 'assignment',
        text: p('SubmissionPage.Columns.Assignment'),
        sortable: false
      });
    }
    if (role === User.IRB_REVIEWER) {
      columns.push({
        data: 'nextMeetingDate',
        text: p('SubmissionPage.Columns.MeetingDate'),
        formatter: dateFormatter(config.dateFormat, new Handlebars.SafeString('<i>N/A</i>')),
        collapsing: true,
        sortable: true,
        type: 'date'
      });
    } else {
      columns.push({
        data: true,
        text: p('SubmissionPage.Columns.DecisionResultDate'),
        childView: DecisionHeaderView,
        childBindings: {
          status: 'decisionStatus',
          date: 'decisionResultDate'
        },
        sortable: false
      });
    }
    columns.push({
      data: 'createDate',
      text: 'Create Date',
      formatter: dateFormatter(),
      sortable: true,
      collapsing: true,
      type: 'date'
    });
    return columns;
  }
  var DOCUMENT_FIELDS = [{
    displayName: p('SubmissionPage.VSFields.Analyst'),
    name: 'analyst',
    autoComplete: {
      entity: 'person',
      field: 'fullName'
    },
    sortName: 'lastName'
  }, {
    displayName: p('SubmissionPage.VSFields.PrimaryReviewer'),
    name: 'primaryReviewer',
    autoComplete: {
      entity: 'person',
      field: 'fullName'
    },
    sortName: 'lastName'
  }, {
    displayName: p('SubmissionPage.VSFields.Decision'),
    name: 'decisionStatus',
    autoComplete: {
      entity: 'decision',
      field: 'type'
    }
  }, {
    displayName: p('SubmissionPage.VSFields.Status'),
    name: 'status',
    autoComplete: {
      entity: 'document',
      field: 'status'
    }
  }, {
    displayName: p('SubmissionPage.VSFields.PI'),
    name: 'principalInvestigator',
    autoComplete: {
      entity: 'person',
      field: 'fullName'
    },
    sortName: 'lastName'
  }, {
    displayName: p('SubmissionPage.VSFields.ReviewType'),
    name: 'reviewType',
    autoComplete: {
      entity: 'review',
      field: 'type'
    }
  }, {
    displayName: p('SubmissionPage.VSFields.SubmissionType'),
    name: 'templateType',
    autoComplete: {
      entity: 'template',
      field: 'type'
    }
  }, {
    displayName: 'Study Title',
    name: 'studyTitle',
    autoComplete: {
      entity: 'study',
      field: 'title'
    },
    sortName: 'title'
  }, {
    displayName: p('SubmissionPage.VSFields.StudyLabel'),
    name: 'studyLabel',
    autoComplete: {
      entity: 'study',
      field: 'label'
    },
    sortName: 'label'
  }, {
    displayName: p('SubmissionPage.VSFields.MyAssignment'),
    name: 'assignment',
    autoComplete: {
      entity: 'assignment',
      field: 'displayName'
    },
    sortName: 'displayName'
  }, {
    displayName: p('SubmissionPage.VSFields.All'),
    name: 'q'
  }];
  var FILTER_OPTIONS = {
    format: {
      analyst: analystFormatter
    }
  };
  var DEFAULT_SORT = {
    sort: 'createDate',
    sortDirection: Sort.DESCENDING
  };
  var SubmissionListController = RegionController.extend({
    header: p('App.Title'),
    onStart: function onStart() {
      var app = this.app,
        region = this.region,
        state = this.state;
      app.execute('achievement:unlock', 'Submitter');
      var root = new PageList({
          sectionTitle: p('SubmissionsPage.Title')
        }),
        submissions = Document.submissions(true),
        table = root.table;
      table.tabletStackable = true;
      table.compact = false;
      table.padded = true;
      root.$el.css(config.contentCss);
      root.setupCollection(submissions, {
        autoFetch: true,
        filter: FILTER_OPTIONS
      }).setupSortDefaults(DEFAULT_SORT).setupLoading().setupEmptyView(EmptyTableView.Row, {
        text: p('SubmissionsPage.NoSubmissions'),
        headerTag: 'h4'
      }).setupVisualSearch(DOCUMENT_FIELDS, state).setupRowLink('submission:detail', {
        studyId: 'studyId',
        documentId: 'id'
      }).setupPaginate().setupPageSizes().setupTableSort();
      function applyAuthority() {
        table.columns.reset(submissionColumns(app.role.get('description')));
        if (app.role.get('description') === User.IRB_ADMIN) {
          root.spfHelper.filter.unset('role');
        } else {
          root.spfHelper.filter.set('role', app.role.get('description'));
        }
      }
      ;
      root.listenTo(app.role, 'change:description', applyAuthority).listenTo(submissions, 'sync', function () {
        region.show(root);
      });
      state.addPageDependencies([submissions]);
      if (app.role.has('description')) {
        applyAuthority();
        submissions.fetch();
      } else {
        app.role.once('change:description', function () {
          submissions.fetch();
        });
      }
    }
  });
  module.exports = SubmissionListController;
});

